module.exports = "/images/vendor/vue-paycard/src/22.jpg?90687de87f895d8e9b6887bba76fe00a";